import { RefObject, useEffect, useMemo, useState } from 'react';
import { useOffersHistoryContext } from '../../../context';

export const useLoader = (containerRef: RefObject<HTMLDivElement | null>, isViewChanged?: boolean): number | undefined => {
  const [loaderHeight, setLoaderHeight] = useState<number>();

  const {
    data: {
      listingSpoiler: { data, isFetching },
    },
  } = useOffersHistoryContext();

  const showMoreButtonHeight = useMemo(() => (data?.totalCountText ? 40 : 0), [data]);

  useEffect(() => {
    /* istanbul ignore else */
    if (containerRef.current && data && !isFetching) {
      setLoaderHeight(containerRef.current.clientHeight + showMoreButtonHeight);
    }
  }, [containerRef, data, isFetching, showMoreButtonHeight, isViewChanged]);

  return loaderHeight;
};
